import { IpDate } from '@ipensii/shared/domain-shared';
import { ObjectUtils } from '@ipensii/shared/util-shared';

interface ExpiryItem {
  key: string;
  value: string;
  expiry: string;
}

export class CacheService implements Storage {
  get length(): number {
    return localStorage.length;
  }

  clear() {
    localStorage.clear();
  }

  key(index: number): string | null {
    return localStorage.key(index);
  }

  removeItem(key: string): void {
    return localStorage.removeItem(key);
  }

  getItem(key: string): string | null {
    const item = localStorage.getItem(key);
    const expiryItem = this.getExpiryItem(item);
    return expiryItem ? this.getValidValue(expiryItem) : item;
  }

  setItem(key: string, value: string, expiry?: IpDate) {
    const item = this.getItem(key);
    if (!item || item !== value) {
      localStorage.setItem(
        key,
        expiry
          ? ObjectUtils.serialize({
              key,
              value,
              expiry: expiry.toDateTimeString(),
            })
          : value
      );
    }
  }

  private getExpiryItem(item: string | null): ExpiryItem | null {
    if (item && ObjectUtils.isJsonString(item)) {
      return ObjectUtils.hasProp(ObjectUtils.deserialize(item), 'expiry')
        ? (ObjectUtils.deserialize(item) as ExpiryItem)
        : null;
    }
    return null;
  }

  private getValidValue(expiryItem: ExpiryItem): string | null {
    if (new IpDate(new Date(expiryItem.expiry)).isAfter(new IpDate())) {
      return expiryItem.value;
    }
    this.removeItem(expiryItem.key);
    return null;
  }
}
